import React from "react";

/* Filled warning triangle — form-level error notices. */
export const AlertIcon = ({ size = 14, className = "shrink-0 mt-px" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M8 1.9L15 14H1L8 1.9z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path d="M8 6.4v3.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="11.6" r="0.8" fill="currentColor" />
  </svg>
);

export default AlertIcon;
